import { render, staticRenderFns } from "./Expertthinktanks.vue?vue&type=template&id=03d7d3a6&scoped=true&"
import script from "./Expertthinktanks.vue?vue&type=script&lang=js&"
export * from "./Expertthinktanks.vue?vue&type=script&lang=js&"
import style0 from "./Expertthinktanks.vue?vue&type=style&index=0&id=03d7d3a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d7d3a6",
  null
  
)

export default component.exports